import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    field: String
  }

  connect() {
    this.timeout = null
    this.element.addEventListener('input', this.save.bind(this))
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.element.removeEventListener('input', this.save.bind(this))
  }

  save(event) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.performSave(event.target.value)
    }, 1000)
  }

  async performSave(value) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const fieldName = this.fieldValue
    const data = {}

    const keys = fieldName.replace(/\]/g, '').split('[')
    let current = data
    for (let i = 0; i < keys.length - 1; i++) {
      current[keys[i]] = {}
      current = current[keys[i]]
    }
    current[keys[keys.length - 1]] = value

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })

      if (response.ok) {
        this.showSaveIndicator()
      } else {
        console.error('Failed to auto-save')
      }
    } catch (error) {
      console.error('Error auto-saving:', error)
    }
  }

  showSaveIndicator() {
    const indicator = document.createElement('span')
    indicator.className = 'text-xs text-green-600 ml-2'
    indicator.textContent = '✓'
    this.element.parentElement.appendChild(indicator)

    setTimeout(() => {
      indicator.remove()
    }, 1500)
  }
}
